import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Type } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListItem } from '../model/list';
import { Router } from '@angular/router';
import { SettingsService } from '../settings.service';


@Component({
  selector: 'app-filter-list',
  templateUrl: './filter-list.component.html',
  styleUrls: ['./filter-list.component.css']
})
export class FilterListComponent implements OnInit, OnDestroy {

  @Input() set data(d: ListItem[]) {
    this.originalList = d
    this.filterItems(this.searachString)
  }
  @Input() showAdd: boolean = true
  @Input() showFilter: boolean = true
  @Input() set loadingPagination( l: boolean) {
    this.showLoading = l
  }

  @Output() addItem: EventEmitter<void> = new EventEmitter()
  @Output() addItemFromList: EventEmitter<void> = new EventEmitter()
  
  showLoading = false
  searachString: string|undefined = undefined
  // for filtering: 
  originalList: ListItem[]
  filteredList$: Observable<ListItem[]|any[]>
  showHDAddMenu = false

  constructor(private router: Router,
    private settingsService: SettingsService) {
   }

  ngOnInit(): void {
    const contextId = this.settingsService.selectedUserContext$.value.identifier
    if(this.router.url === `/cockpit/${contextId}/objects/HuntingDistrict` )
      this.showHDAddMenu = true
  }

  ngOnDestroy() {}

  filterItems(searchString) {
    this.searachString = searchString
    if (!searchString) {
      this.filteredList$ = of(this.originalList)
    } else {
      this.filteredList$ = of(this.originalList)
      .pipe(
        map(el => el.filter(el => el.data.searchFilter(searchString)))
      )
    }

    this.originalList.sort(function (x,y) {
      return ( (y.data.timeStamp ? new Date(y.data.timeStamp).getTime() : 0  ) <  (x.data.timeStamp ? new Date(x.data.timeStamp).getTime() : 0 ) ) ? -1 : 1
      // return ((y.data.timeStamp ? new Date(y.data.timeStamp).getTime() : ( y.data.creationDate ? new Date(y.data.timeStamp).getTime() : 0 )) - (x.data.timeStamp ? new Date(x.data.timeStamp).getTime() : ( x.data.creationDate ? new Date(x.data.creationDate).getTime() : 0 ))) ? 1 : -1
    })
    
  }

  createDocument() {
    this.addItem.emit()
  }

  createDocumentFromList(){
    this.addItemFromList.emit()
  }
}
